import { useEffect, createContext } from "react";
import { Identify, identify, track } from "@amplitude/analytics-browser";
import * as amplitude from "@amplitude/analytics-browser";
import { isAndroidApp, isIOSApp, isWeb } from "../utils/user-agent";
// import { sessionReplayPlugin } from "@amplitude/plugin-session-replay-browser";
import { postMessage } from "./message";

const AMPLITUDE_API_KEY = process.env.REACT_APP_AMPLITUDE_API_KEY;

interface Context {
  trackAmplitudeEvent: (eventName: string, eventProperties: any) => void;
}

export const AmplitudeContext = createContext<Context>({} as Context);
// session replay는 이 자리에 있어야 함.
// 중복 선언 시 warning 발생
// todo: 에러가 뜨는데 아마 샘플링 한도가 다되어 에러가 나는 거 같음. 무슨 동작할 때마다 0.1초씩 딜레이 나길래 주석처리.
// const sessionReplay = sessionReplayPlugin({ sampleRate: 0.1 });
// amplitude.add(sessionReplay);

const AmplitudeContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  useEffect(() => {
    if (!AMPLITUDE_API_KEY) return;

    const mahiUUID = localStorage.getItem("mahi_uuid");
    const sellerToken = localStorage.getItem("sellerToken");

    amplitude.init(AMPLITUDE_API_KEY, mahiUUID || undefined, {
      defaultTracking: {
        sessions: false,
        pageViews: true,
      },
    });

    // 앱도 동일한 UUID로 초기화
    if (mahiUUID) {
      postMessage("REQ_AMPLITUDE_INIT", { mahiUUID });
    }

    const identifyUser = new Identify();

    const isAppDownloaded = isAndroidApp() || isIOSApp();
    if (isAppDownloaded) {
      identifyUser.set("isAppDownloaded", true);
    } else {
      identifyUser.set("isAppDownloaded", false);
    }

    if (isAndroidApp()) {
      identifyUser.set("mahi_platform", "Android App");
    } else if (isIOSApp()) {
      identifyUser.set("mahi_platform", "iOS App");
    } else if (isWeb()) {
      identifyUser.set("mahi_platform", "Web");
    }
    const loadAddr = localStorage.getItem("loadAddr");
    if (loadAddr) identifyUser.set("loadAddr", loadAddr);

    if (sellerToken) {
      identifyUser.set("isSeller", true);
    }

    const jwt = localStorage.getItem("jwt");
    if (jwt) {
      identifyUser.set("isRegisteredUser", true);
    }

    identify(identifyUser);
  }, []);

  const trackAmplitudeEvent = (eventName: string, eventProperties: any) => {
    track(eventName, eventProperties);
  };

  const value = { trackAmplitudeEvent };

  return (
    <AmplitudeContext.Provider value={value}>
      {children}
    </AmplitudeContext.Provider>
  );
};

export default AmplitudeContextProvider;
